import { render, staticRenderFns } from "./LevelCatalog.vue?vue&type=template&id=184f4a5b&"
import script from "./LevelCatalog.vue?vue&type=script&lang=js&"
export * from "./LevelCatalog.vue?vue&type=script&lang=js&"
import style0 from "./LevelCatalog.vue?vue&type=style&index=0&id=184f4a5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports